import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { downloadFile } from "services/ConfigServices";
import { energyData } from "variables/lists/bills";
import { dico } from "variables/lists/dico";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewLogsDialog(props) {
  const { closeModal, datafile } = props;

  const [valueChoice, setValueChoice] = useState("successmessages");
  const [data, setData] = useState([]);
  const classes = useStyles();

  const handleValueChoiceChange = (event) => { 
    setValueChoice(event.target.value); 
  };
  console.log(datafile);

  const columns = [
    {
      name: "Logs",
      selector: (row) => row,
      sortable: true,
      // cell: (row) => row ?
      //   <div>
      //     {dico.find((x) => x.id == row.key).name}
      //   </div> : <></>
    },
  ];

  const choiceData = [{ name: 'Succès', id: 'successmessages' },{ name: 'Avertissements', id: 'warningmessages' },{ name: 'Erreurs', id: 'errormessages' }];

  useEffect(() => {
    if(datafile)
    {
      setData(datafile.logs[valueChoice]);
    }
    
  }, [valueChoice,datafile]);


  return (
    <>
      <form className={classes.root}>
        {datafile &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <DataList>
                <DataContainer>
                  <Data>{"Nombre de succès"}</Data>
                  <DataResult>{datafile.logs.successcount}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Nombre d'avertissements"}</Data>
                  <DataResult>{datafile.logs.warningcount}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Nombre d'erreurs"}</Data>
                  <DataResult>{datafile.logs.errorcount}</DataResult>
                </DataContainer>
              </DataList>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <CustomSelect
                  inputTitle={"Détail"}
                  selectValue={valueChoice}
                  handleSelectValueChange={handleValueChoiceChange}
                  data={choiceData}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Container>
                <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                  dense
                  noDataComponent={<NoData>Aucun détail à afficher</NoData>}
                  noHeader={true}
                  columns={columns}
                  persistTableHead
                  data={data}
                />
              </Container>
            </GridItem>
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewLogsDialog;
